import type { AppTextName } from '../types/types'

export const APP_TEXT_TAG_MAP: Record<AppTextName, string> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body1: 'p',
  'body1-medium': 'p',
  body2: 'p',
  'body2-medium': 'p',
  body3: 'p',
  'body3-medium': 'p',
  body4: 'p',
  'body4-medium': 'p',
}

export const APP_TEXT_BREAKPOINTS = [375, 740, 1024, 1280] as const
